import React from "react";
import Image from "next/image";

import { SxProps, useTheme } from "@mui/material/styles";
import { MeshGradientContainer } from "./MeshGradient.styles";
import { PositionStyles } from "./MeshGradient.variants";
import {
  MeshGradientAssetsBottom,
  MeshGradientAssetsRight,
} from "./MeshGradient.assets";

export type MeshColours = "red-green-teal" | "orange-pink" | "teal-green" | "pink-purple-green" | "pink-blue-teal" | "blue-green-teal" | "light-gold" | "strong-gold";

export interface CustomVariantMeshGradientProps {
  size?: "low" | "high";
  position?: "bottom" | "right" | "top";
  intensity?: "low" | "high", 
  colour: MeshColours,
  sx?: SxProps
}

export const MeshGradient = ({
  size = "low",
  position = "bottom",
  intensity = "low",
  colour,
  sx,
  ...rest
}: CustomVariantMeshGradientProps) => {
  let MeshGradientObject = MeshGradientAssetsBottom;

  switch (position) {
    case 'right':
      MeshGradientObject = MeshGradientAssetsRight;
      break;
    case 'top':
      MeshGradientObject = MeshGradientAssetsBottom;
      break;
    default:
      MeshGradientObject = MeshGradientAssetsBottom;
  }

  const theme = useTheme();
  const positionStylesFn = PositionStyles(theme);
  const MeshStyleSwitch = () => {


    let src = "";
    switch (colour) {
      case "orange-pink":
        if (size === "high") {
          src = MeshGradientObject.OrangePinkHigh;
        } else {
          src = MeshGradientObject.OrangePinkLow;
        }
        break;
    
      case "blue-green-teal":
        if (size === "high") {
          src = MeshGradientObject.BlueGreenTealHigh;
        } else {
          src = MeshGradientObject.BlueGreenTealLow;
        }
        break;
    
      case "pink-purple-green":
        if (size === "high") {
          src = MeshGradientObject.PinkPurpleGreenHigh;
        } else {
          src = MeshGradientObject.PinkPurpleGreenLow;
        }
        break;
    
      case "red-green-teal":
        if (size === "high") {
          src = MeshGradientObject.RedGreenTealHigh;
        } else {
          src = MeshGradientObject.RedGreenTealLow;
        }
        break;
    
      case "teal-green":
        if (size === "high") {
          src = MeshGradientObject.TealGreenHigh;
        } else {
          src = MeshGradientObject.TealGreenLow;
        }
        break;
    
      case "pink-blue-teal":
        if (size === "high") {
          src = MeshGradientObject.PinkBlueTealHigh;
        } else {
          src = MeshGradientObject.PinkBlueTealLow;
        }
        break;

      case "light-gold":
        if (size === "high") {
          src = MeshGradientObject.LightGoldLow;
        } else {
          src = MeshGradientObject.LightGoldLow;
        }
        break;

      case "strong-gold":
        if (size === "high") {
          src = MeshGradientObject.StrongGoldLow;
        } else {
          src = MeshGradientObject.StrongGoldLow;
        }
        break;
    
      default:
        src = MeshGradientObject.PinkBlueTealLow;
    }

    return (
      <Image
        style={{opacity: intensity === "high" ? 1 : 0.6}}
        alt="Gradient"
        fill
        src={src}
        draggable="false"
      />
    );
  };

  return (
    <MeshGradientContainer
      sx={{
        ...positionStylesFn[position],
        ...sx
      }}
      {...rest}
    >
      {MeshStyleSwitch()}
    </MeshGradientContainer>
  );
};

export interface MeshGradientProps
  extends React.ComponentProps<typeof MeshGradient> {
  as?: React.ElementType;
}

MeshGradient.displayName = "MeshGradient";
